import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import {format, parseISO, subMonths, addMonths, startOfMonth} from "date-fns";
import sv from "date-fns/locale/sv";
import React from 'react';
import { Alert, Button, Col, Container, FormControl, FormGroup, FormLabel, Row, Table } from 'react-bootstrap';
import { BsExclamationCircleFill, BsPlus } from "react-icons/bs";
import StyledSelect from '../../components/StyledSelect';
import ogonremissLogo from '../../images/logo-blue.png';
import './Report.css';


const FakturaunderlagReport = ({ events, careUnits, filter, updateEventListFilter, errorMessage }) => {

  const fromInputRef = React.createRef();
  const beforeInputRef = React.createRef();
  const onFilterChange = () => {
    filter.from = fromInputRef.current.value;
    filter.before = beforeInputRef.current.value;
    updateEventListFilter(filter);
  }

  const setFilterMonth = (date) => {
    fromInputRef.current.value = format(startOfMonth(date), 'yyyy-MM-dd');
    beforeInputRef.current.value = format(startOfMonth(addMonths(date, 1)), 'yyyy-MM-dd');
    onFilterChange();
  }
  
  function GeneratePDF() {
    const doc = new jsPDF({ orientation: "portrait", compress: true });

    const logo = new Image();
    logo.src = ogonremissLogo;
    doc.addImage(logo, "PNG", 14, 10, 100, 12.5);

    doc.setFontSize(18);
    doc.text("Fakturaunderlag", 14, 35);
    doc.setFontSize(10);
    doc.text("Skapad: " + format(new Date(), 'yyyy-MM-dd:HH:mm'), 14, 42);
    doc.text("Från och med: " + filter.from, 14, 47);
    doc.text("Till: " + filter.before, 14, 52);

    const filteredCareUnits = filter.careUnitOrganizationId
      ? careUnits.filter(careUnit => careUnit.organizationId === filter.careUnitOrganizationId)
      : careUnits;

    var moms = 25;
    var pdfTotalPrice = 0;
    const tableRows = filteredCareUnits.map((careUnit, index) => {
      const eventsAmount = events.filter(
        (e) => e.type === 'REFERRAL_TRANSMISSION_SUCCESS' && e.receiverOrganizationId === careUnit.organizationId
      ).length;
      const totalEventsPrice = eventsAmount * careUnit.referralPrice;
      pdfTotalPrice += totalEventsPrice;
      return [index + 1, careUnit.name, "Remiss", careUnit.referralPrice, eventsAmount, totalEventsPrice];
    });

    autoTable(doc, {
      startY: 58,
      head: [["#", "Titel", "Beskrivning", "Pris", "Kvantitet", "Total"]],
      body: tableRows,
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 50 },
        2: { cellWidth: 60 },
      },
      styles: { fontSize: 10 },
      headStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255] },
      theme: 'striped',
      tableLineColor: [200, 200, 200],
      tableLineWidth: 0.1,
    });

    let y = doc.lastAutoTable.finalY + 10;
    const rightX = 195;

    doc.setFontSize(10);
    doc.text("Summa:", rightX - 60, y);
    doc.text(pdfTotalPrice.toFixed(2) + " kr", rightX, y, { align: "right" });

    y += 7;
    doc.text("Momsbelopp 25%:", rightX - 60, y);
    doc.text(parseFloat(pdfTotalPrice * (1 + moms / 100) - pdfTotalPrice).toFixed(2) + " kr", rightX, y, { align: "right" });

    y += 7;
    doc.setFontSize(14);
    doc.text("Att betala:", rightX - 60, y);
    doc.text(parseFloat(pdfTotalPrice * (1 + moms / 100)).toFixed(2) + " kr", rightX, y, { align: "right" });

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(10);
      doc.text("Page " + i + " / " + pageCount, doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() - 10, { align: "center" });
    }

    doc.save(`Ogonremiss_Fakturaunderlag_${format(new Date(), 'yyyy-MM-dd')}.pdf`);
  }

  const createInvoiceClicked = (e) => {
    GeneratePDF()
  }

  const eventType = (t) => {
    switch (t) {
      case 'REFERRAL_TRANSMISSION_SUCCESS':
        return 'OK';
      case 'REFERRAL_TRANSMISSION_FAILED_CLIENT':
        return 'KLIENTFEL';
      case 'REFERRAL_TRANSMISSION_FAILED_SERVER':
        return 'SERVERFEL (COS)';
      case 'REFERRAL_TRANSMISSION_FAILED_REST_CLIENT':
        return 'KOMMUNIKATIONSFEL';
      default:
        return 'ANNAN'
    }
  }


  return (
    <div className="FakturaunderlagReport">
      <Container id={"fakturaUnderlagMainGrid"}>
        {errorMessage &&
          <Row>
            <Col xs={12} md={12} lg={12}>
              <Alert variant={"danger"}>
                <b><BsExclamationCircleFill /> {errorMessage}</b>
              </Alert>
            </Col>
          </Row>
        }
        <Row>
          <Col xs={12} md={12} lg={12}>
            <h1>Fakturaunderlag</h1>
          </Col>
        </Row>
        <Row>
          <Col className="mb-xs-3" xs={12} sm={6} md={4} lg={3}>
            <FormGroup controlId="formHorizontalFrom">
              <FormLabel>Från och med (inkl. valt datum)</FormLabel>
              <FormControl
                type="date"
                name="fromDate"
                placeholder="Datum ÅÅÅÅ-MM-DD"
                ref={fromInputRef}
                onChange={() => onFilterChange()}
                onClick={(e) => e.target.showPicker()}
                defaultValue={filter.from ? filter.from : ""}
              />
            </FormGroup>
          </Col>
          <Col className="mb-xs-3" xs={12} sm={6} md={4} lg={3}>
            <FormGroup controlId="formHorizontalBefore">
              <FormLabel>Till (exkl. valt datum)</FormLabel>
              <FormControl
                type="date"
                name="beforeDate"
                placeholder="Datum ÅÅÅÅ-MM-DD"
                ref={beforeInputRef}
                onChange={() => onFilterChange()}
                onClick={(e) => e.target.showPicker()}
                defaultValue={filter.before ? filter.before : ""}
              />
            </FormGroup>
          </Col>
          <Col className="mb-xs-3" xs={12} sm={6} md={4} lg={3}>
            <FormGroup controlId="formHorizontalReceivingOrganization">
              <FormLabel>Kund</FormLabel>
              <StyledSelect
                value={filter.careUnitOrganizationId || ""}
                placeholder="Alla kunder"
                options={[
                  {value: "", label: "Alla kunder"},
                  ...(careUnits || []).map(o => ({value: o.organizationId, label: o.name}))
                ]}
                onChange={(val) => updateEventListFilter({...filter, careUnitOrganizationId: val})}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col className="mb-xs-3" xs={12} sm={12} md={4} lg={3}>
            <h2>Sammanställning</h2>
            <p><b>Godkända remisser: {events.filter((e) => e.type === 'REFERRAL_TRANSMISSION_SUCCESS').length}</b></p>
            <p>Klientfel från COS (4XX - fel anrop till COS): {events.filter((e) => e.type === 'REFERRAL_TRANSMISSION_FAILED_CLIENT').length}</p>
            <p>Serverfel från COS (5XX - fel i COS): {events.filter((e) => e.type === 'REFERRAL_TRANSMISSION_FAILED_SERVER').length}</p>
            <p>Kommunikationsfel mot COS: {events.filter((e) => e.type === 'REFERRAL_TRANSMISSION_FAILED_REST_CLIENT').length}</p>
          </Col>
          <Col xs={12} sm={12} md={8} lg={6}>
            <h2>Snabbval</h2>
            <ul>
              {Array.from({ length: 6 }).map((e, i) =>
                <li key={i}>
                  <a href="" onClick={(e) => { e.preventDefault(); setFilterMonth(subMonths(new Date(), i)) }}>
                    {format(subMonths(new Date(), i), "MMMM-yy", {locale: sv})}
                  </a>
                </li>
              )}
            </ul>
          </Col>
          <Col xs={12} sm={12} md={12} lg={3} className="d-flex align-items-end justify-content-end">
            <Button className={"create mb-3"} onClick={createInvoiceClicked}>
              <BsPlus /> Skapa
            </Button>
          </Col>
        </Row>
        <Table size="sm" hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Tid</th>
            <th>Användar-Id</th>
            <th>Avsändare</th>
            <th>HSA-id avsändare</th>
            <th>Mottagare</th>
            <th>HSA-id mottagare</th>
            <th>Remiss-id</th>
            <th>Status</th>
            <th>Typ</th>
          </tr>
        </thead>
        <tbody>
          {
            events && events.map((event, index) =>
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{format(parseISO(event.timestamp), 'yyyy-MM-dd hh:mm:ss')}</td>
                <td>{event.userId}</td>
                <td>{event.senderOrganizationName}</td>
                <td>{event.senderOrganizationHsaId}</td>
                <td>{event.receiverOrganizationName}</td>
                <td>{event.receiverOrganizationHsaId}</td>
                <td>{event.referralId}</td>
                <td>{event.returnedStatusCode}</td>
                <td>{eventType(event.type)}</td>
              </tr>
            )
          }
        </tbody>
      </Table>
      </Container>
    </div>)
}
export default FakturaunderlagReport;